import { Box } from "@mui/material";
import AdminSideNavLayout from "./components/AdminSideNavLayout/AdminSideNavLayout";
import AdminProfileSection from "./components/AdminProfileSection/AdminProfileSection";
import adminDashboardStyles from "./AdminDashboard.styles";

const AdminProfilePage = () => {
  const styles = adminDashboardStyles;
  return (
    <AdminSideNavLayout>
      <Box sx={styles.root}>
        <Box sx={styles.section}>
          <AdminProfileSection />
        </Box>
      </Box>
    </AdminSideNavLayout>
  );
};

export default AdminProfilePage;
